import React, { useState, useEffect, useRef } from 'react';

function NewArrivals({ onCategorySelect }) {
  const sectionRef = useRef(null);
  const [scrollProgress, setScrollProgress] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const fullTitle = 'Edición\n14 de \nFebrero';

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
        if (!entry.isIntersecting) {
          // Resetear cuando sale de vista
          setScrollProgress(0);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    const interval = setInterval(() => {
      setScrollProgress(prev => {
        if (prev >= 0.99) {
          return 0; // Volver al inicio para loop continuo
        }
        return prev + 0.0015; // Velocidad más lenta para las polaroids
      });
    }, 30);

    return () => clearInterval(interval);
  }, [isVisible]);

  const arrivals = [
    {
      id: 1,
      title: 'Edición 14 de Febrero',
      image: '/images/arrivals/14febind2.jpeg'
    },
    {
      id: 2,
      title: 'Fragancias Especiales',
      image: '/images/arrivals/14febfragancias.jpeg'
    },
    {
      id: 3,
      title: 'Set Individual',
      image: '/images/arrivals/14febind3.jpeg'
    },
    {
      id: 4,
      title: 'Fragancias Premium',
      image: '/images/arrivals/14febfragancias3.jpeg'
    }
  ];

  // Calcular cuál card debe estar visible basado en el progreso
  const getCurrentCardIndex = () => {
    return Math.floor(scrollProgress * arrivals.length);
  };

  const currentIndex = getCurrentCardIndex();

  return (
    <section className="new-arrivals" ref={sectionRef}>
      <div className="arrivals-content">
        <div className="arrivals-left">
          <h2 className="arrivals-title">
            {fullTitle.split('\n').map((line, lineIndex) => (
              <React.Fragment key={lineIndex}>
                {line.split('').map((char, charIndex) => (
                  <span
                    key={`${lineIndex}-${charIndex}`}
                    className="letter-fade-arrivals"
                    style={{ animationDelay: `${5 + (lineIndex * line.length + charIndex) * 0.08}s` }}
                  >
                    {char === ' ' ? '\u00A0' : char}
                  </span>
                ))}
                {lineIndex < fullTitle.split('\n').length - 1 && <br />}
              </React.Fragment>
            ))}
          </h2>
        </div>

        <div className="arrivals-center">
          <div className="polaroids-container">
            {arrivals.map((item, index) => {
              const isVisible = index === currentIndex;
              const isPast = index < currentIndex;
              
              return (
                <div 
                  key={item.id} 
                  className={`polaroid-card ${isVisible ? 'visible' : ''} ${isPast ? 'past' : ''}`}
                  style={{ 
                    animationDelay: `${5.5 + index * 0.2}s`,
                    zIndex: arrivals.length - index,
                    cursor: 'pointer'
                  }}
                  onClick={() => onCategorySelect && onCategorySelect(null)}
                >
                  <div className="polaroid-image">
                    <img src={item.image} alt={item.title} />
                  </div>
                  <div className="polaroid-caption">
                    <h3>{item.title}</h3>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="arrivals-right">
          <div className="arrivals-description">
            <p>
              Nuestra colección especial del 14 de Febrero está diseñada para celebrar el amor y crear momentos inolvidables. Cada fragancia evoca romance y pasión.
            </p>
            <p>
              Encuentra el regalo perfecto para esa persona especial. Sets exclusivos con presentaciones elegantes que expresan tus sentimientos de la manera más aromática.
            </p>
            <p>
              Edición limitada disponible solo por tiempo limitado. Sorprende con un aroma único.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default NewArrivals;
